import React, { useEffect, useState } from 'react';
import './ChooseYourPrinterType.css'
import Container from "reactstrap/es/Container";
import { useTranslation} from 'react-i18next';
import DisplayPrinterType from '../../../../../../components/Web/HardwareSignUp/DisplayPrinterType/DisplayPrinterType';
import { useHistory } from 'react-router-dom';
import { WebHardwareInclusiveRoutePath } from '../../../../../../constants/Routes';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHardwareInclusiveCounter, GetHardwareInclusivePrinterFeaturesByPrinterType, GetHardwareInclusiveServicePlan } from '../../../../../../actions/HardwareInclusive/HardwareInclusive';
import Loader from '../../../../../../components/shared/loader/Loader';
import { findValueByKey_From_ArrayOfObj, formatNumberOnLocale } from '../../../../../../constants/AppMethod';
import ServiceUnavailable from '../ServiceUnavailable/ServiceUnavailable';
import currencies from '../../../../../../constants/CurrencyTypes';
import { calculateLowestPrinterPrices, getPrinterTypeDetails, sortFeaturesInDescendingOrder } from '../../../../../../utils/HardwareInclusive/HardwareInclusive';
import HardwareSignupHeader from '../HardwareSignupHeader/HardwareSignupHeader';
import { featureSwitchName, PRINTER_DISPLAY_TYPE, PRINTER_TYPE, PRINTER_TYPE_API_MAP } from '../../../../../../constants/AppConstants';
import { GetNewPBServicePlanInit } from '../../../../../../store/HardwareInclusive/GetNewPrinterBundleServicePlanSlice';

const ChooseYourPrinterType = () => {
    const { t } = useTranslation(['translation'])
    const history = useHistory()
    const dispatch = useDispatch();
    const printerFeaturesByPrinterTypeResult = useSelector((state) => state.GetHWPrinterFeaturesByPrinterType)
    const servicePlanHWResult = useSelector((state) => state.GetHWServicePlan);
    const servicePlanNPBResult = useSelector(state => state.ROOTREDUCER_RTK.GetNewPrinterBundleServicePlan);
    const {
        loading: HWInc_StockInfo_Loading,
        success: HWInc_StockInfo_success,
        data: HWInc_StockInfo
    } = useSelector(state => state.HardwareInclusiveCounter_FETCH)
    const hardwareFeatureFlags = useSelector(state => state.GetHWPrinterFeaturesByPrinterType.hardwareFeatureFlags);


    const [lowestInkPlan, setLowestInkPlan] = useState({
        monthly: null,
        dueToday: null
    });

    const [lowestLaserPlan, setLowestLaserPlan] = useState({
        monthly: null,
        dueToday: null
    });
    const [expandedId, setExpandedId] = useState(null);

    const handleToggle = (id) => {
        setExpandedId(prev => prev === id ? null : id);
    };
    const payloadForFeatureSwitch = `${featureSwitchName.HARDWARE_INCLUSIVE},${featureSwitchName.NEW_PRINTER_BUNDLE},${featureSwitchName.BONUS_PAGES}`

    const moveToCustomizePrinter = (printerTypeId, startingPrice, printerType, defaultImageURL) => {
        history.push({ pathname: WebHardwareInclusiveRoutePath.CUSTOMIZE_PRINTER, state: { "printerTypeId": printerTypeId, "printerPrice": startingPrice, "printerType": printerType, "defaultImageURL": defaultImageURL } })
    }

    useEffect(() => {

        if (!printerFeaturesByPrinterTypeResult?.loading && !printerFeaturesByPrinterTypeResult?.success) {
            dispatch(GetHardwareInclusivePrinterFeaturesByPrinterType(payloadForFeatureSwitch));
        }

        if (!HWInc_StockInfo_Loading && !HWInc_StockInfo_success) {
            dispatch(fetchHardwareInclusiveCounter());
        }

    }, [
        printerFeaturesByPrinterTypeResult?.loading,
        printerFeaturesByPrinterTypeResult?.success,
        HWInc_StockInfo_Loading,
        HWInc_StockInfo_success,
        payloadForFeatureSwitch,
        dispatch
    ]);

    useEffect(() => {
        if (!printerFeaturesByPrinterTypeResult?.success || !hardwareFeatureFlags) return;

        if (
            (hardwareFeatureFlags?.isHWOnly || hardwareFeatureFlags?.isBothEnabled) &&
            !servicePlanHWResult?.success &&
            !servicePlanHWResult?.loading
        ) {
            dispatch(GetHardwareInclusiveServicePlan());
        }

        if (
            (hardwareFeatureFlags?.isNPBOnly || hardwareFeatureFlags?.isBothEnabled) &&
            !servicePlanNPBResult?.newPBServicePlan_success &&
            !servicePlanNPBResult?.newPBServicePlan_loading
        ) {
            dispatch(GetNewPBServicePlanInit());
        }

    }, [
        printerFeaturesByPrinterTypeResult?.success,
        hardwareFeatureFlags,
        servicePlanNPBResult,
        servicePlanHWResult,
        dispatch
    ]);
    useEffect(() => {

        if (!hardwareFeatureFlags) return;

        const hwProducts = servicePlanHWResult?.allServicePlans?.products || [];
        const npbProducts = servicePlanNPBResult?.allServicePlans?.products || [];

        const prices = calculateLowestPrinterPrices(
            hwProducts,
            npbProducts,
            hardwareFeatureFlags
        );

        setLowestInkPlan(prices.ink);
        setLowestLaserPlan(prices.laser);

    }, [
        hardwareFeatureFlags,
        servicePlanHWResult?.allServicePlans?.products,
        servicePlanNPBResult?.allServicePlans?.products
    ]);


    const getPriceAndCurrencyBasedOnType = (printerTypeId, type, priceType = "monthly") => {

        const plan =
            printerTypeId === PRINTER_TYPE.INKJET
                ? lowestInkPlan
                : lowestLaserPlan;

        const selectedPlan = plan?.[priceType];

        if (!selectedPlan) return null;

        return type === "currency"
            ? selectedPlan.currency
            : selectedPlan.price;
    };

    const VerifyHWIncStocks = (printerTypeId) => {
        let isStockAvailable = true;
        const HWInc_StockDetails = HWInc_StockInfo?.hardwareInclusivePrinterStockDetailsViewModel;
        if (HWInc_StockInfo_success && HWInc_StockDetails) {
            const stockCount = findValueByKey_From_ArrayOfObj(HWInc_StockDetails, 'printerTypeId', printerTypeId, 'availableUnits')
            isStockAvailable = (stockCount > 0 || stockCount === null) ? true : false;
        }
        return isStockAvailable;
    }
    if (
        printerFeaturesByPrinterTypeResult?.loading
        || servicePlanHWResult?.loading
        || HWInc_StockInfo_Loading
        || servicePlanNPBResult?.newPBServicePlan_loading
    ) {
        return <Loader />
    }
    if (printerFeaturesByPrinterTypeResult?.service_available_err) {
        return <ServiceUnavailable />
    }
    const transformedprinterTypeFeatures = {
        printerTypeFeatures: [
            printerFeaturesByPrinterTypeResult?.printerFeatures?.printerTypeFeatures?.find(
                p => p.printerType === PRINTER_TYPE_API_MAP[PRINTER_TYPE.INKJET]
            ),
            {
                ...(printerFeaturesByPrinterTypeResult?.printerFeatures?.printerTypeFeatures?.find(
                    p => p.printerType === (hardwareFeatureFlags?.isHWOnly ? PRINTER_TYPE_API_MAP[PRINTER_TYPE.MONO_LASER] : PRINTER_TYPE_API_MAP[PRINTER_TYPE.COLOUR_LASER])
                ) || {}),
                printerType: hardwareFeatureFlags?.isHWOnly ? PRINTER_TYPE_API_MAP[PRINTER_TYPE.MONO_LASER] : PRINTER_DISPLAY_TYPE.LASER,
                printerTypeId: hardwareFeatureFlags?.isHWOnly ? PRINTER_TYPE.MONO_LASER : PRINTER_TYPE.COLOUR_LASER
            }
        ].filter(Boolean)
    }
    return (
        <div className='hardware-choose-printer'>
            <HardwareSignupHeader />
            <div className='choose-printer-header'>{t("HARDWARE_SIGNUP.CHOOSE_PRINTER_TYPE.HEADER")}</div>
            <Container className="hardware-choose-printer-container">
                <div className='hardware-printer-content-wrapper'>
                    {printerFeaturesByPrinterTypeResult?.success && transformedprinterTypeFeatures?.printerTypeFeatures?.map(printerFeature => {
                        const currencyCode = getPriceAndCurrencyBasedOnType(printerFeature?.printerTypeId, "currency", "monthly");
                        const startingPrice = getPriceAndCurrencyBasedOnType(printerFeature?.printerTypeId, "price", "monthly");
                        const dueTodayPrice = getPriceAndCurrencyBasedOnType(printerFeature?.printerTypeId, "price", "dueToday");
                        const formattedStartingPrice = formatNumberOnLocale(startingPrice, currencies[currencyCode]?.code)
                        const formattedDueTodayPrice = formatNumberOnLocale(dueTodayPrice, currencies[currencyCode]?.code)
                        const isPrinterStocksAvailable = VerifyHWIncStocks(printerFeature?.printerTypeId);
                        return (
                            <DisplayPrinterType
                                printerTypeId={printerFeature?.printerTypeId}
                                printerName={printerFeature?.printerType}
                                printerInfo={getPrinterTypeDetails(printerFeature?.printerTypeId)?.info}
                                printerDescription={getPrinterTypeDetails(printerFeature?.printerTypeId)?.description}
                                moveToCustomizePrinter={() => moveToCustomizePrinter(printerFeature?.printerTypeId, startingPrice, printerFeature.printerType, printerFeature?.deviceTypeImageUrl)}
                                planStartingPrice={formattedStartingPrice}
                                deviceImg={printerFeature?.deviceTypeImageUrl}
                                printerFeatures={sortFeaturesInDescendingOrder(printerFeature.features)}
                                isPrinterStocksAvailable={isPrinterStocksAvailable}
                                hardwareFeatureFlags={hardwareFeatureFlags}
                                isExpanded={expandedId === printerFeature?.printerTypeId}
                                onToggle={() => handleToggle(printerFeature?.printerTypeId)}
                                dueTodayPrice={formattedDueTodayPrice}
                            ></DisplayPrinterType>
                        )
                    }
                    )}
                </div>
            </Container>
        </div>
    );
};

export default ChooseYourPrinterType;
